import { render, staticRenderFns } from "./ApprovedLeaseItem.vue?vue&type=template&id=47f8bcba&"
import script from "./ApprovedLeaseItem.vue?vue&type=script&lang=js&"
export * from "./ApprovedLeaseItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47f8bcba')) {
      api.createRecord('47f8bcba', component.options)
    } else {
      api.reload('47f8bcba', component.options)
    }
    module.hot.accept("./ApprovedLeaseItem.vue?vue&type=template&id=47f8bcba&", function () {
      api.rerender('47f8bcba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/leases/components/ApprovedLeaseItem.vue"
export default component.exports